export const COLECTIONS = {
	company_configs: 'company_configs',
	ui_states: 'ui_states',
	apply_forms: 'apply_forms',

	profile_infos: 'profile_infos',
	profile_skill_specialty: 'profile_skill_specialty',
	profile_resume: 'profile_resume',
	profile_references: 'profile_references',
	profile_educations: 'profile_educations',

	activations: 'activations',
	activation_resume: 'activation_resume',
	activation_skill_specialty: 'activation_skill_specialty',
	activation_references: 'activation_references',
	activation_verifications: 'activation_verifications',
	onboarding_percentage: 'onboardingPercents',

	time_card_current: 'time_card_current',
	time_card_detail: 'time_card_detail',
	time_cards: 'time_cards',
	last_job_id: 'last_job_id',
}

export const REIMBURSEMENTS_CONST = '_reimbursements'
